import { PRESUPUESTADOR_SET_SORT_FINANCIAL_LINE } from './constants'

export function setSortFinancialLine(name) {
    return { type: PRESUPUESTADOR_SET_SORT_FINANCIAL_LINE, name }
}

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_SORT_FINANCIAL_LINE) {
        return { ...state, sortFinancialLine: action.name }
    } else {
        return state
    }
}
